import { render, staticRenderFns } from "./courseCard.vue?vue&type=template&id=44499e8f&"
import script from "./courseCard.vue?vue&type=script&lang=js&"
export * from "./courseCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports